import { createReducer } from 'redux-create-reducer';
import {
  caseNameUpdateAction,
  requestFormAction,
  receiveFormAction,
} from '../actions/form';
import { selectCustomerAction, addCustomerAction } from '../actions/customers';
import {
  selectSiteAction,
  unselectSiteAction,
  addSiteAction,
} from '../actions/sites';
import { selectContactAction } from '../actions/contacts';

const initialState = {
  name: '',
  customerId: undefined,
  siteIds: [],
  contacts: [],
  isFetching: false,
  errors: [],
};

const ERRORS = 'errors';

export const formReducer = createReducer(initialState, {
  [caseNameUpdateAction](state, action) {
    return {
      ...state,
      name: action.payload,
    };
  },
  [selectCustomerAction](state, action) {
    return {
      ...state,
      customerId: parseInt(action.payload, 10),
      siteIds: [],
    };
  },
  [addCustomerAction](state, action) {
    return {
      ...state,
      customerId: parseInt(action.payload.id, 10),
    };
  },
  [requestFormAction](state) {
    return {
      ...state,
      isFetching: true,
    };
  },
  [receiveFormAction](state, action) {
    return {
      ...action.payload,
      errors: [],
      isFetching: false,
    };
  },
  [selectSiteAction](state, action) {
    const ids = state.siteIds.slice();
    ids.push(action.payload.id);
    return {
      ...state,
      siteIds: ids,
    };
  },
  [unselectSiteAction](state, action) {
    return {
      ...state,
      siteIds: state.siteIds.filter(
        id => id.toString() !== action.payload.id.toString()
      ),
    };
  },
  [addSiteAction](state, action) {
    const ids = state.siteIds.slice();
    ids.push(action.payload.id);
    return {
      ...state,
      siteIds: ids,
    };
  },
  [selectContactAction](state, action) {
    const contacts = state.contacts
      .slice()
      .filter(c => c.site !== action.payload.site);
    contacts.push({
      contact: parseInt(action.payload.contact, 10),
      site: action.payload.site,
    });
    return {
      ...state,
      contacts: contacts,
    };
  },
  [ERRORS](state, action) {
    return {
      ...state,
      errors: action.payload,
    };
  },
});

export default formReducer;

export const getName = state => state.form.name;
export const getForm = state => state.form;
export const getSelectedSites = state => state.form.siteIds;
export const getSelectedContacts = state => state.form.contacts;
export const getCustomerId = state =>
  state.form.customerId && state.form.customerId.toString();
export const getErrors = state => state.form.errors;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step1/reducers/form.js